module.exports = __webpack_public_path__ + "img/btn_Play.6b5974b5.svg";